import React from "react";

export const Coordinate = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6.5" cy="8.5" r="1.5" fill="currentColor" />
      <rect
        x="-0.5"
        y="-0.5"
        width="6"
        height="17"
        rx="1.5"
        transform="matrix(9.93477e-08 1 1 -9.93477e-08 4 14)"
        stroke="currentColor"
      />
      <line x1="15.5" y1="14" x2="15.5" y2="16" stroke="currentColor" />
      <line x1="12.5" y1="14" x2="12.5" y2="16" stroke="currentColor" />
      <line x1="9.5" y1="14" x2="9.5" y2="17" stroke="currentColor" />
      <line x1="6.5" y1="14" x2="6.5" y2="16" stroke="currentColor" />
    </svg>
  );
};
export const CoordinateActive = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6.5" cy="8.5" r="1.5" fill="#FF6700" />
      <rect
        x="-0.5"
        y="-0.5"
        width="6"
        height="17"
        rx="1.5"
        transform="matrix(9.93477e-08 1 1 -9.93477e-08 4 14)"
        stroke="currentColor"
      />
      <line x1="15.5" y1="14" x2="15.5" y2="16" stroke="currentColor" />
      <line x1="12.5" y1="14" x2="12.5" y2="16" stroke="currentColor" />
      <line x1="9.5" y1="14" x2="9.5" y2="17" stroke="currentColor" />
      <line x1="6.5" y1="14" x2="6.5" y2="16" stroke="currentColor" />
    </svg>
  );
};
export const CoordinateFilled = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6.5" cy="7.5" r="1.5" fill="currentColor" />
      <path
        d="M21 17C21 18.1046 20.1046 19 19 19L5 19C3.89543 19 3 18.1046 3 17L3 14C3 12.8954 3.89543 12 5 12L19 12C20.1046 12 21 12.8954 21 14L21 17ZM4.00488 17.1025L4.01855 17.1953L4.02051 17.2012C4.01372 17.1688 4.00829 17.136 4.00488 17.1025ZM7 13L6 13L6 16L7 16L7 13ZM9 13L9 17L10 17L10 13L9 13ZM12 13L12 16L13 16L13 13L12 13ZM15 13L15 16L16 16L16 13L15 13ZM19.96 13.7178C19.9685 13.7468 19.9755 13.7765 19.9814 13.8066L19.9824 13.8105C19.9764 13.7791 19.9689 13.7481 19.96 13.7178ZM19.9795 17.2012C19.974 17.2283 19.9676 17.255 19.96 17.2813C19.9768 17.2236 19.9889 17.1639 19.9951 17.1025L19.9795 17.2012Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Distance = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6.5" cy="7.5" r="1.5" fill="currentColor" />
      <circle cx="17.5" cy="7.5" r="1.5" fill="currentColor" />
      <rect x="9" y="7" width="6" height="1" fill="currentColor" />
      <rect
        x="-0.5"
        y="-0.5"
        width="6"
        height="17"
        rx="1.5"
        transform="matrix(9.93477e-08 1 1 -9.93477e-08 4 13)"
        stroke="currentColor"
      />
      <line x1="15.5" y1="13" x2="15.5" y2="15" stroke="currentColor" />
      <line x1="12.5" y1="13" x2="12.5" y2="15" stroke="currentColor" />
      <line x1="9.5" y1="13" x2="9.5" y2="16" stroke="currentColor" />
      <line x1="6.5" y1="13" x2="6.5" y2="15" stroke="currentColor" />
    </svg>
  );
};
export const DistanceActive = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6.5" cy="7.5" r="1.5" fill="currentColor" />
      <circle cx="17.5" cy="7.5" r="1.5" fill="currentColor" />
      <rect x="9" y="7" width="6" height="1" fill="#FF6700" />
      <rect
        x="-0.5"
        y="-0.5"
        width="6"
        height="17"
        rx="1.5"
        transform="matrix(9.93477e-08 1 1 -9.93477e-08 4 13)"
        stroke="currentColor"
      />
      <line x1="15.5" y1="13" x2="15.5" y2="15" stroke="currentColor" />
      <line x1="12.5" y1="13" x2="12.5" y2="15" stroke="currentColor" />
      <line x1="9.5" y1="13" x2="9.5" y2="16" stroke="currentColor" />
      <line x1="6.5" y1="13" x2="6.5" y2="15" stroke="currentColor" />
    </svg>
  );
};
export const DistanceFilled = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6.5" cy="7.5" r="1.5" fill="currentColor" />
      <circle cx="17.5" cy="7.5" r="1.5" fill="currentColor" />
      <rect x="9" y="7" width="6" height="1" fill="currentColor" />
      <path
        d="M21 17C21 18.1046 20.1046 19 19 19L5 19C3.89543 19 3 18.1046 3 17L3 14C3 12.8954 3.89543 12 5 12L19 12C20.1046 12 21 12.8954 21 14L21 17ZM4.00488 17.1025L4.01855 17.1953L4.02051 17.2012C4.01372 17.1688 4.00829 17.136 4.00488 17.1025ZM7 13L6 13L6 16L7 16L7 13ZM9 13L9 17L10 17L10 13L9 13ZM12 13L12 16L13 16L13 13L12 13ZM15 13L15 16L16 16L16 13L15 13ZM19.96 13.7178C19.9685 13.7468 19.9755 13.7765 19.9814 13.8066L19.9824 13.8105C19.9764 13.7791 19.9689 13.7481 19.96 13.7178ZM19.9795 17.2012C19.974 17.2283 19.9676 17.255 19.96 17.2813C19.9768 17.2236 19.9889 17.1639 19.9951 17.1025L19.9795 17.2012Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Area = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="5.5" cy="11.5" r="1.5" fill="currentColor" />
      <circle cx="17.5" cy="11.5" r="1.5" fill="currentColor" />
      <rect x="8" y="11" width="7" height="1" fill="currentColor" />
      <rect
        x="17"
        y="9"
        width="2"
        height="1"
        transform="rotate(-90 17 9)"
        fill="currentColor"
      />
      <circle cx="8.5" cy="4.5" r="1.5" fill="currentColor" />
      <circle cx="17.5" cy="4.5" r="1.5" fill="currentColor" />
      <rect x="11" y="4" width="4" height="1" fill="currentColor" />
      <rect
        x="6.05104"
        y="9.16736"
        width="2.96284"
        height="1"
        transform="rotate(-66.0599 6.05104 9.16736)"
        fill="currentColor"
      />
      <rect
        x="-0.5"
        y="-0.5"
        width="6"
        height="17"
        rx="1.5"
        transform="matrix(9.93477e-08 1 1 -9.93477e-08 4 15)"
        stroke="currentColor"
      />
      <line x1="15.5" y1="15" x2="15.5" y2="17" stroke="currentColor" />
      <line x1="12.5" y1="15" x2="12.5" y2="17" stroke="currentColor" />
      <line x1="9.5" y1="15" x2="9.5" y2="18" stroke="currentColor" />
      <line x1="6.5" y1="15" x2="6.5" y2="17" stroke="currentColor" />
    </svg>
  );
};

export const AreaActive = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="5.5" cy="11.5" r="1.5" fill="currentColor" />
      <circle cx="17.5" cy="11.5" r="1.5" fill="currentColor" />
      <rect x="8" y="11" width="7" height="1" fill="#FF6700" />
      <rect
        x="17"
        y="9"
        width="2"
        height="1"
        transform="rotate(-90 17 9)"
        fill="#FF6700"
      />
      <circle cx="8.5" cy="4.5" r="1.5" fill="currentColor" />
      <circle cx="17.5" cy="4.5" r="1.5" fill="currentColor" />
      <rect x="11" y="4" width="4" height="1" fill="#FF6700" />
      <rect
        x="6.05104"
        y="9.16736"
        width="2.96284"
        height="1"
        transform="rotate(-66.0599 6.05104 9.16736)"
        fill="#FF6700"
      />
      <rect
        x="-0.5"
        y="-0.5"
        width="6"
        height="17"
        rx="1.5"
        transform="matrix(9.93477e-08 1 1 -9.93477e-08 4 15)"
        stroke="currentColor"
      />
      <line x1="15.5" y1="15" x2="15.5" y2="17" stroke="currentColor" />
      <line x1="12.5" y1="15" x2="12.5" y2="17" stroke="currentColor" />
      <line x1="9.5" y1="15" x2="9.5" y2="18" stroke="currentColor" />
      <line x1="6.5" y1="15" x2="6.5" y2="17" stroke="currentColor" />
    </svg>
  );
};

export const AreaFilled = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="5.5" cy="11.5" r="1.5" fill="currentColor" />
      <circle cx="17.5" cy="11.5" r="1.5" fill="currentColor" />
      <rect x="8" y="11" width="7" height="1" fill="currentColor" />
      <rect
        x="17"
        y="9"
        width="2"
        height="1"
        transform="rotate(-90 17 9)"
        fill="currentColor"
      />
      <circle cx="8.5" cy="4.5" r="1.5" fill="currentColor" />
      <circle cx="17.5" cy="4.5" r="1.5" fill="currentColor" />
      <rect x="11" y="4" width="4" height="1" fill="currentColor" />
      <rect
        x="6.05104"
        y="9.16736"
        width="2.96284"
        height="1"
        transform="rotate(-66.0599 6.05104 9.16736)"
        fill="currentColor"
      />
      <path
        d="M21 19C21 20.1046 20.1046 21 19 21L5 21C3.89543 21 3 20.1046 3 19L3 16C3 14.8954 3.89543 14 5 14L19 14C20.1046 14 21 14.8954 21 16L21 19ZM4.00488 19.1025L4.01855 19.1953L4.02051 19.2012C4.01372 19.1688 4.00829 19.136 4.00488 19.1025ZM7 15L6 15L6 18L7 18L7 15ZM9 15L9 19L10 19L10 15L9 15ZM12 15L12 18L13 18L13 15L12 15ZM15 15L15 18L16 18L16 15L15 15ZM19.96 15.7178C19.9685 15.7468 19.9755 15.7765 19.9814 15.8066L19.9824 15.8105C19.9764 15.7791 19.9689 15.7481 19.96 15.7178ZM19.9795 19.2012C19.974 19.2283 19.9676 19.255 19.96 19.2813C19.9768 19.2236 19.9889 19.1639 19.9951 19.1025L19.9795 19.2012Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const VerticalDistance = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16.5" cy="4.5" r="1.5" fill="currentColor" />
      <rect x="16" y="7" width="1" height="13" fill="currentColor" />
      <rect x="14" y="20" width="5" height="1" fill="currentColor" />
      <rect
        x="0.5"
        y="-0.5"
        width="6"
        height="17"
        rx="1.5"
        transform="matrix(-1 0 0 1 11 4)"
        stroke="currentColor"
      />
      <line x1="10" y1="15.5" x2="8" y2="15.5" stroke="currentColor" />
      <line x1="10" y1="12.5" x2="8" y2="12.5" stroke="currentColor" />
      <line x1="10" y1="9.5" x2="7" y2="9.5" stroke="currentColor" />
      <line x1="10" y1="6.5" x2="8" y2="6.5" stroke="currentColor" />
    </svg>
  );
};
export const VerticalDistanceActive = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="-0.5"
        width="6"
        height="17"
        rx="1.5"
        transform="matrix(-1 0 0 1 11 4)"
        stroke="currentColor"
      />
      <line x1="10" y1="15.5" x2="8" y2="15.5" stroke="currentColor" />
      <line x1="10" y1="12.5" x2="8" y2="12.5" stroke="currentColor" />
      <line x1="10" y1="9.5" x2="7" y2="9.5" stroke="currentColor" />
      <line x1="10" y1="6.5" x2="8" y2="6.5" stroke="currentColor" />
      <circle cx="16.5" cy="4.5" r="1.5" fill="currentColor" />
      <rect x="16" y="7" width="1" height="13" fill="#FF6700" />
      <rect x="14" y="20" width="5" height="1" fill="currentColor" />
    </svg>
  );
};
export const VerticalDistanceFilled = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 21C4.89543 21 4 20.1046 4 19L4 5C4 3.89543 4.89543 3 6 3L9 3C10.1046 3 11 3.89543 11 5L11 19C11 20.1046 10.1046 21 9 21L6 21ZM5.89746 4.00488L5.80469 4.01855L5.79883 4.02051C5.83117 4.01372 5.86403 4.00829 5.89746 4.00488ZM10 7L10 6L7 6L7 7L10 7ZM10 9L6 9L6 10L10 10L10 9ZM10 12L7 12L7 13L10 13L10 12ZM10 15L7 15L7 16L10 16L10 15ZM9.28223 19.96C9.25315 19.9685 9.22348 19.9755 9.19336 19.9814L9.18945 19.9824C9.22092 19.9764 9.25188 19.9689 9.28223 19.96ZM5.79883 19.9795C5.77174 19.974 5.74499 19.9676 5.71875 19.96C5.77636 19.9768 5.83606 19.9889 5.89746 19.9951L5.79883 19.9795Z"
        fill="currentColor"
      />
      <circle cx="16.5" cy="4.5" r="1.5" fill="currentColor" />
      <rect x="16" y="7" width="1" height="13" fill="currentColor" />
      <rect x="14" y="20" width="5" height="1" fill="currentColor" />
    </svg>
  );
};

export const SurveyWheel = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9" cy="9" r="1.5" stroke="currentColor" />
      <path d="M11 7L14 4L18 4" stroke="currentColor" />
      <rect
        x="-0.5"
        y="-0.5"
        width="6"
        height="17"
        rx="1.5"
        transform="matrix(9.93477e-08 1 1 -9.93477e-08 4 13)"
        stroke="currentColor"
      />
      <line x1="15.5" y1="13" x2="15.5" y2="15" stroke="currentColor" />
      <line x1="12.5" y1="13" x2="12.5" y2="15" stroke="currentColor" />
      <line x1="9.5" y1="13" x2="9.5" y2="16" stroke="currentColor" />
      <line x1="6.5" y1="13" x2="6.5" y2="15" stroke="currentColor" />
    </svg>
  );
};
export const SurveyWheelActive = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="-0.5"
        y="-0.5"
        width="6"
        height="17"
        rx="1.5"
        transform="matrix(9.93477e-08 1 1 -9.93477e-08 4 13)"
        stroke="currentColor"
      />
      <line x1="15.5" y1="13" x2="15.5" y2="15" stroke="currentColor" />
      <line x1="12.5" y1="13" x2="12.5" y2="15" stroke="currentColor" />
      <line x1="9.5" y1="13" x2="9.5" y2="16" stroke="currentColor" />
      <line x1="6.5" y1="13" x2="6.5" y2="15" stroke="currentColor" />
      <circle cx="9" cy="9" r="1.5" stroke="#FF6700" />
      <path d="M11 7L14 4L18 4" stroke="currentColor" />
    </svg>
  );
};
export const SurveyWheelFilled = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 17C21 18.1046 20.1046 19 19 19L5 19C3.89543 19 3 18.1046 3 17L3 14C3 12.8954 3.89543 12 5 12L19 12C20.1046 12 21 12.8954 21 14L21 17ZM4.00488 17.1025L4.01855 17.1953L4.02051 17.2012C4.01372 17.1688 4.00829 17.136 4.00488 17.1025ZM7 13L6 13L6 16L7 16L7 13ZM9 13L9 17L10 17L10 13L9 13ZM12 13L12 16L13 16L13 13L12 13ZM15 13L15 16L16 16L16 13L15 13ZM19.96 13.7178C19.9685 13.7468 19.9755 13.7765 19.9814 13.8066L19.9824 13.8105C19.9764 13.7791 19.9689 13.7481 19.96 13.7178ZM19.9795 17.2012C19.974 17.2283 19.9676 17.255 19.96 17.2813C19.9768 17.2236 19.9889 17.1639 19.9951 17.1025L19.9795 17.2012Z"
        fill="currentColor"
      />
      <circle cx="9" cy="9" r="1.5" stroke="currentColor" />
      <path d="M11 7L14 4L18 4" stroke="currentColor" />
    </svg>
  );
};

export const OrthogonalDistance = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6.5" cy="4.5" r="1.5" fill="currentColor" />
      <rect x="9" y="4" width="8" height="1" fill="currentColor" />
      <rect
        x="17"
        y="11"
        width="7"
        height="1"
        transform="rotate(-90 17 11)"
        fill="currentColor"
      />
      <rect
        x="17"
        y="9"
        width="3"
        height="1"
        transform="rotate(-180 17 9)"
        fill="currentColor"
      />
      <rect
        x="14"
        y="9"
        width="1"
        height="4"
        transform="rotate(-180 14 9)"
        fill="currentColor"
      />
      <rect
        x="-0.5"
        y="-0.5"
        width="6"
        height="17"
        rx="1.5"
        transform="matrix(9.93477e-08 1 1 -9.93477e-08 4 13)"
        stroke="currentColor"
      />
      <line x1="15.5" y1="13" x2="15.5" y2="15" stroke="currentColor" />
      <line x1="12.5" y1="13" x2="12.5" y2="15" stroke="currentColor" />
      <line x1="9.5" y1="13" x2="9.5" y2="16" stroke="currentColor" />
      <line x1="6.5" y1="13" x2="6.5" y2="15" stroke="currentColor" />
    </svg>
  );
};
export const OrthogonalDistanceActive = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="-0.5"
        y="-0.5"
        width="6"
        height="17"
        rx="1.5"
        transform="matrix(9.93477e-08 1 1 -9.93477e-08 4 13)"
        stroke="currentColor"
      />
      <line x1="15.5" y1="13" x2="15.5" y2="15" stroke="currentColor" />
      <line x1="12.5" y1="13" x2="12.5" y2="15" stroke="currentColor" />
      <line x1="9.5" y1="13" x2="9.5" y2="16" stroke="currentColor" />
      <line x1="6.5" y1="13" x2="6.5" y2="15" stroke="currentColor" />
      <circle cx="6.5" cy="4.5" r="1.5" fill="currentColor" />
      <rect x="9" y="4" width="8" height="1" fill="#FF6700" />
      <rect
        x="17"
        y="11"
        width="7"
        height="1"
        transform="rotate(-90 17 11)"
        fill="currentColor"
      />
      <rect
        x="17"
        y="9"
        width="3"
        height="1"
        transform="rotate(-180 17 9)"
        fill="currentColor"
      />
      <rect
        x="14"
        y="9"
        width="1"
        height="4"
        transform="rotate(-180 14 9)"
        fill="currentColor"
      />
    </svg>
  );
};
export const OrthogonalDistanceFilled = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 17C21 18.1046 20.1046 19 19 19L5 19C3.89543 19 3 18.1046 3 17L3 14C3 12.8954 3.89543 12 5 12L19 12C20.1046 12 21 12.8954 21 14L21 17ZM4.00488 17.1025L4.01855 17.1953L4.02051 17.2012C4.01372 17.1688 4.00829 17.136 4.00488 17.1025ZM7 13L6 13L6 16L7 16L7 13ZM9 13L9 17L10 17L10 13L9 13ZM12 13L12 16L13 16L13 13L12 13ZM15 13L15 16L16 16L16 13L15 13ZM19.96 13.7178C19.9685 13.7468 19.9755 13.7765 19.9814 13.8066L19.9824 13.8105C19.9764 13.7791 19.9689 13.7481 19.96 13.7178ZM19.9795 17.2012C19.974 17.2283 19.9676 17.255 19.96 17.2813C19.9768 17.2236 19.9889 17.1639 19.9951 17.1025L19.9795 17.2012Z"
        fill="currentColor"
      />
      <circle cx="6.5" cy="4.5" r="1.5" fill="currentColor" />
      <rect x="9" y="4" width="8" height="1" fill="currentColor" />
      <rect
        x="17"
        y="11"
        width="7"
        height="1"
        transform="rotate(-90 17 11)"
        fill="currentColor"
      />
      <rect
        x="17"
        y="9"
        width="3"
        height="1"
        transform="rotate(-180 17 9)"
        fill="currentColor"
      />
      <rect
        x="14"
        y="9"
        width="1"
        height="4"
        transform="rotate(-180 14 9)"
        fill="currentColor"
      />
    </svg>
  );
};

export const Profile = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="4.5" cy="9.5" r="1.5" fill="currentColor" />
      <circle cx="19.5" cy="4.5" r="1.5" fill="currentColor" />
      <path d="M6 8L10 4L16 8L18 6" stroke="currentColor" />
      <rect
        x="-0.5"
        y="-0.5"
        width="6"
        height="17"
        rx="1.5"
        transform="matrix(9.93477e-08 1 1 -9.93477e-08 4 13)"
        stroke="currentColor"
      />
      <line x1="15.5" y1="13" x2="15.5" y2="15" stroke="currentColor" />
      <line x1="12.5" y1="13" x2="12.5" y2="15" stroke="currentColor" />
      <line x1="9.5" y1="13" x2="9.5" y2="16" stroke="currentColor" />
      <line x1="6.5" y1="13" x2="6.5" y2="15" stroke="currentColor" />
    </svg>
  );
};
export const ProfileActive = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="-0.5"
        y="-0.5"
        width="6"
        height="17"
        rx="1.5"
        transform="matrix(9.93477e-08 1 1 -9.93477e-08 4 13)"
        stroke="currentColor"
      />
      <line x1="15.5" y1="13" x2="15.5" y2="15" stroke="currentColor" />
      <line x1="12.5" y1="13" x2="12.5" y2="15" stroke="currentColor" />
      <line x1="9.5" y1="13" x2="9.5" y2="16" stroke="currentColor" />
      <line x1="6.5" y1="13" x2="6.5" y2="15" stroke="currentColor" />
      <circle cx="4.5" cy="9.5" r="1.5" fill="currentColor" />
      <circle cx="19.5" cy="4.5" r="1.5" fill="currentColor" />
      <path d="M6 8L10 4L16 8L18 6" stroke="#FF6700" />
    </svg>
  );
};
export const ProfileFilled = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 17C21 18.1046 20.1046 19 19 19L5 19C3.89543 19 3 18.1046 3 17L3 14C3 12.8954 3.89543 12 5 12L19 12C20.1046 12 21 12.8954 21 14L21 17ZM4.00488 17.1025L4.01855 17.1953L4.02051 17.2012C4.01372 17.1688 4.00829 17.136 4.00488 17.1025ZM7 13L6 13L6 16L7 16L7 13ZM9 13L9 17L10 17L10 13L9 13ZM12 13L12 16L13 16L13 13L12 13ZM15 13L15 16L16 16L16 13L15 13ZM19.96 13.7178C19.9685 13.7468 19.9755 13.7765 19.9814 13.8066L19.9824 13.8105C19.9764 13.7791 19.9689 13.7481 19.96 13.7178ZM19.9795 17.2012C19.974 17.2283 19.9676 17.255 19.96 17.2813C19.9768 17.2236 19.9889 17.1639 19.9951 17.1025L19.9795 17.2012Z"
        fill="currentColor"
      />
      <circle cx="4.5" cy="9.5" r="1.5" fill="currentColor" />
      <circle cx="19.5" cy="4.5" r="1.5" fill="currentColor" />
      <path d="M6 8L10 4L16 8L18 6" stroke="currentColor" />
    </svg>
  );
};

export const Linref = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6.5" cy="4.5" r="1.5" fill="currentColor" />
      <rect x="6" y="7" width="1" height="3" fill="currentColor" />
      <rect x="6" y="10" width="6" height="1" fill="currentColor" />
      <rect
        x="15.2691"
        y="8.19266"
        width="3"
        height="1"
        transform="rotate(-56.9855 15.2691 8.19266)"
        fill="currentColor"
      />
      <rect
        x="12"
        y="13.2239"
        width="3"
        height="1"
        transform="rotate(-56.9855 12 13.2239)"
        fill="currentColor"
      />
      <rect
        x="17.4485"
        y="4.83853"
        width="1"
        height="1"
        transform="rotate(-56.9855 17.4485 4.83853)"
        fill="currentColor"
      />
      <rect
        x="14.1794"
        y="9.86973"
        width="1"
        height="1"
        transform="rotate(-56.9855 14.1794 9.86973)"
        fill="currentColor"
      />
      <rect
        x="-0.5"
        y="-0.5"
        width="6"
        height="17"
        rx="1.5"
        transform="matrix(4.37114e-08 1 1 -4.37114e-08 4 16)"
        stroke="currentColor"
      />
      <line x1="15.5" y1="16" x2="15.5" y2="18" stroke="currentColor" />
      <line x1="12.5" y1="16" x2="12.5" y2="18" stroke="currentColor" />
      <line x1="9.5" y1="16" x2="9.5" y2="19" stroke="currentColor" />
      <line x1="6.5" y1="16" x2="6.5" y2="18" stroke="currentColor" />
    </svg>
  );
};
export const LinrefActive = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="-0.5"
        y="-0.5"
        width="6"
        height="17"
        rx="1.5"
        transform="matrix(4.37114e-08 1 1 -4.37114e-08 4 16)"
        stroke="currentColor"
      />
      <line x1="15.5" y1="16" x2="15.5" y2="18" stroke="currentColor" />
      <line x1="12.5" y1="16" x2="12.5" y2="18" stroke="currentColor" />
      <line x1="9.5" y1="16" x2="9.5" y2="19" stroke="currentColor" />
      <line x1="6.5" y1="16" x2="6.5" y2="18" stroke="currentColor" />
      <circle cx="6.5" cy="4.5" r="1.5" fill="currentColor" />
      <rect x="6" y="7" width="1" height="3" fill="#FF6700" />
      <rect x="6" y="10" width="6" height="1" fill="#FF6700" />
      <rect
        x="15.2691"
        y="8.19266"
        width="3"
        height="1"
        transform="rotate(-56.9855 15.2691 8.19266)"
        fill="currentColor"
      />
      <rect
        x="12"
        y="13.2239"
        width="3"
        height="1"
        transform="rotate(-56.9855 12 13.2239)"
        fill="currentColor"
      />
      <rect
        x="17.4485"
        y="4.83853"
        width="1"
        height="1"
        transform="rotate(-56.9855 17.4485 4.83853)"
        fill="currentColor"
      />
      <rect
        x="14.1794"
        y="9.86973"
        width="1"
        height="1"
        transform="rotate(-56.9855 14.1794 9.86973)"
        fill="currentColor"
      />
    </svg>
  );
};
export const LinrefFilled = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 20C21 21.1046 20.1046 22 19 22L5 22C3.89543 22 3 21.1046 3 20L3 17C3 15.8954 3.89543 15 5 15L19 15C20.1046 15 21 15.8954 21 17L21 20ZM4.00488 20.1025L4.01855 20.1953L4.02051 20.2012C4.01372 20.1688 4.00829 20.136 4.00488 20.1025ZM7 16L6 16L6 19L7 19L7 16ZM9 16L9 20L10 20L10 16L9 16ZM12 16L12 19L13 19L13 16L12 16ZM15 16L15 19L16 19L16 16L15 16ZM19.96 16.7178C19.9685 16.7468 19.9755 16.7765 19.9814 16.8066L19.9824 16.8105C19.9764 16.7791 19.9689 16.7481 19.96 16.7178ZM19.9795 20.2012C19.974 20.2283 19.9676 20.255 19.96 20.2813C19.9768 20.2236 19.9889 20.1639 19.9951 20.1025L19.9795 20.2012Z"
        fill="currentColor"
      />
      <circle cx="6.5" cy="4.5" r="1.5" fill="currentColor" />
      <rect x="6" y="7" width="1" height="3" fill="currentColor" />
      <rect x="6" y="10" width="6" height="1" fill="currentColor" />
      <rect
        x="15.2691"
        y="8.19266"
        width="3"
        height="1"
        transform="rotate(-56.9855 15.2691 8.19266)"
        fill="currentColor"
      />
      <rect
        x="12"
        y="13.2239"
        width="3"
        height="1"
        transform="rotate(-56.9855 12 13.2239)"
        fill="currentColor"
      />
      <rect
        x="17.4485"
        y="4.83853"
        width="1"
        height="1"
        transform="rotate(-56.9855 17.4485 4.83853)"
        fill="currentColor"
      />
      <rect
        x="14.1794"
        y="9.86973"
        width="1"
        height="1"
        transform="rotate(-56.9855 14.1794 9.86973)"
        fill="currentColor"
      />
    </svg>
  );
};

export const Cursor = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5046_14961)">
        <path
          d="M12 4.56757C5.92324 4.56757 1 7.8973 1 12C1 16.1027 5.92324 19.4324 12 19.4324C18.0768 19.4324 23 16.1027 23 12C23 7.8973 18.0768 4.56757 12 4.56757ZM12 17.3514C7.73081 17.3514 4.27027 14.9611 4.27027 12C4.27027 9.03892 7.73081 6.64865 12 6.64865C16.2692 6.64865 19.7297 9.03892 19.7297 12C19.7297 14.9611 16.2692 17.3514 12 17.3514Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const CursorWithPoints = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5046_14962)">
        <path
          d="M5.93227 6.81248C5.9548 6.57316 5.60931 6.34489 5.16059 6.30264C4.71186 6.26038 4.32983 6.42013 4.30729 6.65945C4.28475 6.89877 4.63024 7.12703 5.07897 7.16929C5.52769 7.21155 5.90973 7.0518 5.93227 6.81248Z"
          fill="currentColor"
        />
        <path
          d="M10.2224 5.98136C10.245 5.74204 9.89947 5.51378 9.45075 5.47152C9.00202 5.42926 8.61999 5.58901 8.59745 5.82833C8.57491 6.06765 8.9204 6.29592 9.36913 6.33817C9.81785 6.38043 10.1999 6.22068 10.2224 5.98136Z"
          fill="currentColor"
        />
        <path
          d="M3.87987 9.74507C3.91368 9.38609 3.39302 9.04346 2.71694 8.97979C2.04086 8.91612 1.46538 9.15552 1.43157 9.5145C1.39777 9.87348 1.91843 10.2161 2.59451 10.2798C3.27059 10.3434 3.84607 10.104 3.87987 9.74507Z"
          fill="currentColor"
        />
        <path
          d="M8.15917 8.91377C8.19298 8.55479 7.67231 8.21216 6.99624 8.14849C6.32016 8.08482 5.74468 8.32422 5.71087 8.6832C5.67706 9.04218 6.19773 9.38481 6.87381 9.44848C7.54989 9.51215 8.12536 9.27275 8.15917 8.91377Z"
          fill="currentColor"
        />
        <path
          d="M12.4482 8.0934C12.482 7.73442 11.9614 7.39179 11.2853 7.32812C10.6092 7.26445 10.0337 7.50385 9.99993 7.86283C9.96613 8.22181 10.4868 8.56443 11.1629 8.6281C11.8389 8.69177 12.4144 8.45238 12.4482 8.0934Z"
          fill="currentColor"
        />
        <path
          d="M16.7277 7.25142C16.7615 6.89244 16.2408 6.54981 15.5647 6.48614C14.8886 6.42247 14.3132 6.66187 14.2794 7.02085C14.2455 7.37983 14.7662 7.72245 15.4423 7.78612C16.1184 7.84979 16.6938 7.6104 16.7277 7.25142Z"
          fill="currentColor"
        />
        <path
          d="M1.91579 12.8213C1.93832 12.5819 1.59283 12.3537 1.14411 12.3114C0.695381 12.2692 0.313347 12.4289 0.290809 12.6682C0.268271 12.9076 0.613764 13.1358 1.06249 13.1781C1.51121 13.2203 1.89325 13.0606 1.91579 12.8213Z"
          fill="currentColor"
        />
        <path
          d="M5.98327 12.1452C6.01707 11.7862 5.49641 11.4436 4.82033 11.3799C4.14425 11.3163 3.56878 11.5557 3.53497 11.9146C3.50116 12.2736 4.02183 12.6163 4.6979 12.6799C5.37398 12.7436 5.94946 12.5042 5.98327 12.1452Z"
          fill="currentColor"
        />
        <path
          d="M10.8899 11.383C10.9401 10.8505 10.1562 10.3412 9.13909 10.2454C8.12198 10.1496 7.25679 10.5036 7.20664 11.0361C7.1565 11.5686 7.94038 12.0779 8.95749 12.1737C9.9746 12.2695 10.8398 11.9155 10.8899 11.383Z"
          fill="currentColor"
        />
        <path
          d="M15.1692 10.5518C15.2194 10.0193 14.4355 9.50999 13.4184 9.4142C12.4013 9.31841 11.5361 9.67243 11.4859 10.2049C11.4358 10.7374 12.2197 11.2467 13.2368 11.3425C14.2539 11.4383 15.1191 11.0843 15.1692 10.5518Z"
          fill="currentColor"
        />
        <path
          d="M18.8409 9.67329C18.8747 9.31431 18.3541 8.97169 17.678 8.90801C17.0019 8.84434 16.4264 9.08374 16.3926 9.44272C16.3588 9.8017 16.8795 10.1443 17.5556 10.208C18.2316 10.2717 18.8071 10.0323 18.8409 9.67329Z"
          fill="currentColor"
        />
        <path
          d="M22.0949 8.92051C22.1174 8.68119 21.7719 8.45293 21.3232 8.41067C20.8745 8.36841 20.4924 8.52816 20.4699 8.76748C20.4473 9.0068 20.7928 9.23506 21.2416 9.27732C21.6903 9.31958 22.0723 9.15983 22.0949 8.92051Z"
          fill="currentColor"
        />
        <path
          d="M4.03017 15.2215C4.0527 14.9822 3.70721 14.7539 3.25849 14.7116C2.80976 14.6694 2.42773 14.8291 2.40519 15.0684C2.38265 15.3078 2.72814 15.536 3.17687 15.5783C3.62559 15.6205 4.00763 15.4608 4.03017 15.2215Z"
          fill="currentColor"
        />
        <path
          d="M8.10729 14.5572C8.1411 14.1982 7.62043 13.8556 6.94435 13.7919C6.26828 13.7283 5.6928 13.9677 5.65899 14.3266C5.62518 14.6856 6.14585 15.0282 6.82193 15.0919C7.49801 15.1556 8.07348 14.9162 8.10729 14.5572Z"
          fill="currentColor"
        />
        <path
          d="M13.0032 13.795C13.0534 13.2625 12.2695 12.7532 11.2524 12.6574C10.2353 12.5616 9.37007 12.9157 9.31993 13.4481C9.26978 13.9806 10.0537 14.4899 11.0708 14.5857C12.0879 14.6815 12.9531 14.3275 13.0032 13.795Z"
          fill="currentColor"
        />
        <path
          d="M17.2932 12.9637C17.3434 12.4312 16.5595 11.9219 15.5424 11.8261C14.5253 11.7303 13.6601 12.0844 13.61 12.6168C13.5598 13.1493 14.3437 13.6586 15.3608 13.7544C16.3779 13.8502 17.2431 13.4962 17.2932 12.9637Z"
          fill="currentColor"
        />
        <path
          d="M20.9541 12.0853C20.9879 11.7263 20.4672 11.3837 19.7912 11.32C19.1151 11.2563 18.5396 11.4957 18.5058 11.8547C18.472 12.2137 18.9927 12.5563 19.6687 12.62C20.3448 12.6837 20.9203 12.4443 20.9541 12.0853Z"
          fill="currentColor"
        />
        <path
          d="M24.2091 11.3207C24.2317 11.0814 23.8862 10.8531 23.4374 10.8109C22.9887 10.7686 22.6067 10.9284 22.5841 11.1677C22.5616 11.407 22.9071 11.6353 23.3558 11.6775C23.8045 11.7198 24.1866 11.56 24.2091 11.3207Z"
          fill="currentColor"
        />
        <path
          d="M10.2208 16.9682C10.2546 16.6092 9.73396 16.2665 9.05788 16.2029C8.3818 16.1392 7.80632 16.3786 7.77252 16.7376C7.73871 17.0966 8.25937 17.4392 8.93545 17.5029C9.61153 17.5665 10.187 17.3271 10.2208 16.9682Z"
          fill="currentColor"
        />
        <path
          d="M14.5 16.137C14.5338 15.778 14.0131 15.4354 13.3371 15.3717C12.661 15.308 12.0855 15.5474 12.0517 15.9064C12.0179 16.2654 12.5385 16.608 13.2146 16.6717C13.8907 16.7354 14.4662 16.496 14.5 16.137Z"
          fill="currentColor"
        />
        <path
          d="M18.7891 15.3165C18.8229 14.9576 18.3022 14.6149 17.6261 14.5513C16.95 14.4876 16.3746 14.727 16.3408 15.086C16.3069 15.445 16.8276 15.7876 17.5037 15.8512C18.1798 15.9149 18.7552 15.6755 18.7891 15.3165Z"
          fill="currentColor"
        />
        <path
          d="M23.0684 14.4854C23.1022 14.1264 22.5815 13.7838 21.9054 13.7201C21.2293 13.6565 20.6539 13.8959 20.6201 14.2549C20.5862 14.6138 21.1069 14.9565 21.783 15.0201C22.4591 15.0838 23.0345 14.8444 23.0684 14.4854Z"
          fill="currentColor"
        />
        <path
          d="M15.9025 18.1716C15.925 17.9323 15.5795 17.704 15.1308 17.6618C14.6821 17.6195 14.3 17.7793 14.2775 18.0186C14.255 18.2579 14.6005 18.4862 15.0492 18.5284C15.4979 18.5707 15.8799 18.4109 15.9025 18.1716Z"
          fill="currentColor"
        />
        <path
          d="M20.1928 17.3404C20.2153 17.1011 19.8698 16.8728 19.4211 16.8306C18.9724 16.7883 18.5903 16.9481 18.5678 17.1874C18.5452 17.4267 18.8907 17.655 19.3395 17.6972C19.7882 17.7395 20.1702 17.5798 20.1928 17.3404Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const EditIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.06 9.01841L14.98 9.93841L5.92 18.9984H5V18.0784L14.06 9.01841ZM17.66 2.99841C17.41 2.99841 17.15 3.09841 16.96 3.28841L15.13 5.11841L18.88 8.86841L20.71 7.03841C21.1 6.64841 21.1 6.01841 20.71 5.62841L18.37 3.28841C18.17 3.08841 17.92 2.99841 17.66 2.99841ZM14.06 6.18841L3 17.2484V20.9984H6.75L17.81 9.93841L14.06 6.18841Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const EditIconActive = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.96 3.29C17.15 3.1 17.41 3 17.66 3C17.92 3 18.17 3.09 18.37 3.29L20.71 5.63C21.1 6.02 21.1 6.65 20.71 7.04L18.88 8.87L15.13 5.12L16.96 3.29Z"
        fill="currentColor"
      />
      <path
        d="M3 17.25L14.06 6.19L17.81 9.94L6.75 21H3V17.25Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Straighten = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5021_10266)">
        <path
          d="M21 6H3C1.9 6 1 6.9 1 8V16C1 17.1 1.9 18 3 18H21C22.1 18 23 17.1 23 16V8C23 6.9 22.1 6 21 6ZM21 16H3V8H5V12H7V8H9V13.76H11V8H13V12H15V8H17V12H19V8H21V16Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
export const StraightenActive = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5021_10274)">
        <path
          d="M21 6H3C1.9 6 1 6.9 1 8V16C1 17.1 1.9 18 3 18H21C22.1 18 23 17.1 23 16V8C23 6.9 22.1 6 21 6ZM7 12H5V8H7V12ZM11 13.76H9V8H11V13.76ZM15 12.01H13V8.01H15V12.01ZM18.99 12.01H16.99V8.01H18.99V12.01Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const LinRefIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" fill="white" />
      <rect
        x="2.5"
        y="14.5"
        width="19"
        height="7"
        rx="1.5"
        stroke="currentColor"
      />
      <rect x="5" y="14" width="1" height="4" rx="0.5" fill="currentColor" />
      <rect x="9" y="14" width="1" height="5" rx="0.5" fill="currentColor" />
      <rect x="13" y="14" width="1" height="4" rx="0.5" fill="currentColor" />
      <rect x="17" y="14" width="1" height="4" rx="0.5" fill="currentColor" />
      <path
        d="M3 6.5H7C7.27614 6.5 7.5 6.72386 7.5 7V11C7.5 11.2761 7.27614 11.5 7 11.5H3C2.72386 11.5 2.5 11.2761 2.5 11V7C2.5 6.72386 2.72386 6.5 3 6.5Z"
        stroke="currentColor"
      />
      <circle cx="20.5" cy="11.5" r="1.5" fill="#FF6700" />
      <path
        d="M2 11.5C2 11.2239 2.22386 11 2.5 11H17.5C17.7761 11 18 11.2239 18 11.5V11.5C18 11.7761 17.7761 12 17.5 12H2.5C2.22386 12 2 11.7761 2 11.5V11.5Z"
        fill="#FF6700"
      />
      <path
        d="M2 2.5C2 2.22386 2.22386 2 2.5 2V2C2.77614 2 3 2.22386 3 2.5V12H2V2.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
